module.exports = __webpack_public_path__ + "media/images/icon_pdf-4f17e69f3f115caf9d49c497436fe376.png";